import { h, render } from "preact";

const getCompatibleProduct = (compatibleProducts, compatibleProductId) => {
  if (!compatibleProducts) return null;

  return compatibleProducts.find(
    ({ product }) => product.id === compatibleProductId
  );
};

export default function CompatibilityRowContent({ products, rowProduct }) {
  return (
    <div className="compare-modal-v2__row-items compare-modal-v2__compatibility-row-items">
      {products.map(({ product }) => {
        const compatibleProduct = getCompatibleProduct(
          product.compatibleProducts,
          rowProduct.id
        );

        if (!compatibleProduct)
          return (
            <div className="compare-modal-v2__row-item compare-modal-v2__compatibility-row-item">
              <svg
                width="16"
                height="17"
                viewBox="0 0 16 17"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M9.71222 11.2752L10.9757 10.012L15.8527 14.8964L14.5893 16.1596L9.71222 11.2752Z"
                  fill="black"
                />
                <path
                  d="M0.449905 2.01494L1.69916 0.765681L8.14893 7.21339L14.5976 0.778189L15.827 2.00761L1.6848 16.1496L0.455382 14.9202L6.89976 8.46275L0.449905 2.01494Z"
                  fill="black"
                />
              </svg>
              <span className="visually-hidden">{`${product.title} is not compatible with ${rowProduct.title}`}</span>
            </div>
          );

        return (
          <div className="compare-modal-v2__row-item compare-modal-v2__compatibility-row-item">
            <svg
              width="24"
              height="25"
              viewBox="0 0 24 25"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M5.67832 11.2093L4 12.8813L9.61305 18.4648L20 8.14299L18.3217 6.46484L9.61305 15.1147L5.67832 11.2093Z"
                fill="black"
              />
            </svg>
            {compatibleProduct.image && (
              <img
                className="compare-modal-v2__compatibility-row-item-image"
                src={getSizedImageUrl(
                  compatibleProduct.image.image.url,
                  "x800"
                )}
                alt={compatibleProduct.image.image.altText}
              />
            )}
            <span className="visually-hidden">{`${product.title} is compatible with ${rowProduct.title}`}</span>
          </div>
        );
      })}
    </div>
  );
}
